/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

interface Category {
  key: string;
  title: string;
}

const initialState: Category[] = [];

// ==============================|| SLICE - MENU ||============================== //

const categorySlice = createSlice({
  name: 'category',
  initialState: {},
  reducers: {
    listCategories: (state, action) => {
      const temp: any = {};
      for (const el of action.payload) {
        temp[el.id] = el;
      }
      return { ...state, ...temp };
    }
  }
});

export default categorySlice.reducer;

export const { listCategories } = categorySlice.actions;
